import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import LanguageContext from '../../contexts/languageContext'
import UsdCircleSVG from '../../../static/assets/icon-usd-circle.svg'
import PlayCircleSVG from '../../../static/assets/icon-play-circle.svg'
import RetweetSVG from '../../../static/assets/icon-retweet.svg'
import BellOnSVG from '../../../static/assets/icon-bell-on.svg'
import HomePageDocumentationItem from './HomePageDocumentationItem'

const HomePageDocumentation = () => {
  const { t } = useTranslation()
  const { lang } = useContext(LanguageContext)

  const documentationItems = useMemo(
    () => [
      {
        id: 'documentation-sales',
        title: t('homePage.documentation.sales.title'),
        subtitle: t('homePage.documentation.sales.subtitle'),
        route: `/${lang}/v1/sales/about-sales/`,
        icon: <UsdCircleSVG />,
        category: 'sales',
      },
      {
        id: 'documentation-member-area',
        title: t('homePage.documentation.memberArea.title'),
        subtitle: t('homePage.documentation.memberArea.subtitle'),
        route: `/${lang}/v1/club/about-club/`,
        icon: <PlayCircleSVG />,
        category: 'club',
      },
      {
        id: 'documentation-subscription',
        title: t('homePage.documentation.subscription.title'),
        subtitle: t('homePage.documentation.subscription.subtitle'),
        route: `/${lang}/v1/subscription/about-subscription/`,
        icon: <RetweetSVG />,
        category: 'subscription',
      },
      {
        id: 'documentation-webhook',
        title: t('homePage.documentation.webhook.title'),
        subtitle: t('homePage.documentation.webhook.subtitle'),
        route: `/${lang}/1.0.0/webhook/about-webhook/`,
        icon: <BellOnSVG />,
        category: 'webhook',
      },
    ],
    [t, lang]
  )

  return (
    <section className={`${styles.documentationWrapper} ${styles.homePageWrapper}`}>
      <div className={styles.documentationgHeader}>
        <h1>{t('homePage.documentation.title')}</h1>
        <h2>{t('homePage.documentation.subtitle')}</h2>
      </div>
      <div className={`${styles.documentationContent}`}>
        {documentationItems.map(item => (
          <HomePageDocumentationItem
            key={item.id}
            title={item.title}
            subtitle={item.subtitle}
            icon={item.icon}
            route={item.route}
            category={item.category}
          />
        ))}
      </div>
    </section>
  )
}

export default HomePageDocumentation
